import React from "react"
import { UserGroupIcon, TrashIcon, PencilIcon } from "@heroicons/react/24/outline"
import { Button } from '../../shadcnComponents/ui/button';

export function ActionBar(props) {
    return (
        <div id='action-bar' className="flex flex-row flex-wrap items-center justify-start py-2 gap-1 mt-2">
            <Button variant="ghost" onClick={() => { props.revealNewGroupMenu() }} >
                <UserGroupIcon className="size-5" />
                <div>Nέα ομάδα</div>
            </Button>
            <Button variant="ghost" onClick={() => { props.revealRenameGroupMenu() }}>
                <PencilIcon className="size-5" />
                <div>Μετονομασία</div>
            </Button>
            <Button variant="ghost" onClick={() => { props.revealDeleteGroupMenu() }}>
                <TrashIcon className="size-5" />
                <div>Διαγραφή</div>
            </Button>
        </div>
    )
}


export default ActionBar